export enum Language {
  English = 'en',

  Hungarian = 'hu',
}

export const LANGUAGE_NAMES = {
  [Language.English]: 'English',
  [Language.Hungarian]: 'Magyar',
};